'use strict';

var FirebaseObject = require('./FirebaseObject');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');

var KayleeRemoteControlSession = {
    fromJson: fromJson,
    getSession: getSession,
};

function fromJson(data) {
    var reqProps = [ '$id' ];
    return FirebaseObject.$fromJson(data, 'RemoteControlSession', reqProps, reqProps,
        function(data) { return getSession(data.$id); }
    );
}

function getSession(sessionId) {
    var key = 'Remote Control Session: ' + sessionId;
    var session = KayleeCache.get(key);

    if (session === null) {
        session = new Session(sessionId);
        KayleeCache.put(key, session);
    }

    return session;
}

function Session(sessionId) {
    this.$nodeType = 'remoteControlSession';
    FirebaseObject.call(this,
        KayleeBase.app.database().ref('remoteControlSessions/' + sessionId));
}

Session.prototype = Object.create(FirebaseObject.prototype);
Session.prototype.constructor = Session;

Session.prototype.$remove = function() {
    return KayleeBase.request('removeRemoteControlSession', { sessionId: this.$id });
};

Session.prototype.$toJson = function() {
    return FirebaseObject.prototype.$toJson.call(this, [ '$id' ]);
};

Session.prototype.toString = function() {
    return '[Remote Control Session (' + this.$id + ')]';
};

module.exports = KayleeRemoteControlSession;
